<div class="flex h-screen bg-slate-100">
  <elcia-main-menu/>
  <div class="flex min-w-0 flex-1 flex-col py-5 pr-5">
    <div
      class="flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-md shadow-slate-900/20">
      <header class="shrink-0">
        <elcia-header/>
      </header>
      <main class="soft-scrollbar flex min-h-0 flex-1 flex-col overflow-y-auto bg-slate-50 px-8 py-8">
        <router-outlet/>
      </main>
    </div>
  </div>
</div>
